import type { FlagType } from "@appchoose/flag";
import { Flag } from "@appchoose/flag";
import i18n from "i18next";

import { countries, formatCountryName } from "~/utils/address";

export const getCountryOptions = () => {
  return countries
    .map((country) => ({
      value: country.code,
      label: formatCountryName(
        country.code.toUpperCase(),
        i18n.language.replace("_", "-"),
      ),
      leftSection: (
        <div className="mr-2 flex h-4 items-center">
          <Flag flag={country.code as FlagType} />
        </div>
      ),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
